<div>
  <ng-content />

  @if (showPagination()) {
    <td-wb-pagination class="td-wb-learn-pagination__pagination"
      [selectedPage]="selectedPage()"
      [itemCount]="totalCount()"
      [itemsPerPage]="contentsPerPage()"
      [scrollIntoViewOnPageChange]="true"
      (selectedPageChange)="onPageClick($event)" />
  }
</div>
